import { type ReactNode, useEffect, useState } from 'react';
import { MaintenanceErrorPage } from '@r/page/error/maintenance-error-page.tsx';
import { subscribeToServerErrors } from '@r/lib/server-error-events.ts';
import type { MaintenancePageReason } from '@r/lib/maintenance-error.ts';

/**
 * Enveloppe l'app (client + admin). Écoute {@link triggerServerError} :
 * - 503 sur n'importe quel endpoint (intercepteur axios)
 * - 500 après retries sur login / locales
 */
export function ServerErrorProvider({ children }: { children: ReactNode }) {
  const [maintenanceReason, setMaintenanceReason] = useState<MaintenancePageReason | null>(null);

  useEffect(() => subscribeToServerErrors((reason) => setMaintenanceReason(reason)), []);

  if (maintenanceReason) {
    return <MaintenanceErrorPage reason={maintenanceReason} />;
  }

  return children;
}
